import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import Header from "../components/Header";
import PageLoader from "../components/PageLoader";
import AuthService from "../services/AuthService";

const ItemDetails = () => {
  const [count, setCount] = useState(1);

  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [cart, setCart] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [total_price, setTotalPrice] = useState(0);
  const [instruction, setInstruction] = useState('');
  const branch = JSON.parse(localStorage.getItem("branch"));
  const address = JSON.parse(localStorage.getItem("address"));
  const navigate = useNavigate();
  const authUser = AuthService.getCurrentUser();
  const type = localStorage.getItem('type') || 'delivery';

   const { pathname } = useLocation();

   useEffect(() => {
     window.scrollTo(0, 0);
     
     // Check if user has address/branch for delivery/pickup
     if (!authUser && !address && !branch) {
       const gotoParam = '/item/'+id;
      //  console.log(authUser);
        navigate(`/?goto=${gotoParam}`);

       return;
     }
     
     getItemDetails();
   }, []);

  useEffect(() => {
    if (item) {
     getCart();
    }
  }, [item]);

   // Handle checkbox change
  const handleCheckboxChange = (addonIndex, addonItem, isChecked) => {
    const addon = item.addons[addonIndex];
    const currentSelected = selectedAddons.filter(
      a => a.addon_index === addonIndex
    ).length;

    if (isChecked) {
      // Check max_selection limit
      if (currentSelected >= addon.max_selection) {
        toast.error('Max selection reached');
        return;
      }

      // Check max_quantity limit for the addon group
      const currentAddonItems = selectedAddons.filter(a => a.addon_index === addonIndex);
      const currentTotalQuantity = currentAddonItems.reduce((sum, item) => sum + item.quantity, 0);
      // Adding 1 because we're trying to add a new item with quantity 1
      if (currentTotalQuantity + 1 > addon.max_quantity) {
        toast.error(`Total quantity for this addon group cannot exceed ${addon.max_quantity}`);
        return;
      }

      // If max selection is 1, set quantity to 1
      const quantity = addon.max_selection === 1 ? 1 : 1;
      setSelectedAddons(prev => [
        ...prev,
        {
          addon_index: addonIndex,
          item_id: addonItem._id,
          title: addonItem.title,
          price: addonItem.price,
          quantity: quantity,
          total_price: quantity * addonItem.price,
          max_selection: addon.max_selection,
          max_quantity: addon.max_quantity,
        }
      ]);
    } else {
      // Remove from selection
      setSelectedAddons(prev => 
        prev.filter(a => 
          !(a.addon_index === addonIndex && a.item_id === addonItem._id)
        )
      )
    }
  };


  // Handle quantity change
  const handleQuantityChange = (addonIndex, itemId, newQuantity) => {
    setSelectedAddons(prev => {
      // Find the addon group being modified
      const addonGroup = prev.find(addon => addon.addon_index === addonIndex);
      
      if (!addonGroup) return prev;

      // Calculate current sum of quantities for this addon group
      const currentAddonItems = prev.filter(a => a.addon_index === addonIndex);
      const currentTotal = currentAddonItems.reduce((sum, item) => sum + item.quantity, 0);
      
      // Calculate what the new total would be
      const currentItem = currentAddonItems.find(a => a.item_id === itemId);
      const newTotal = currentTotal - (currentItem?.quantity || 0) + newQuantity;
      console.log(newTotal);

      // Validate against min/max rules
      // if (newQuantity < addonGroup.min_quantity) {
      //   alert(`Minimum quantity for this addon is ${addonGroup.min_quantity}`);
      //   return prev;
      // }

      if (newTotal > addonGroup.max_quantity) {
        toast.error(`Total quantity for this addon group cannot exceed ${addonGroup.max_quantity}`);
        return prev;
      }

      // If validations pass, update the quantity
      return prev.map(addon => {
        if (addon.addon_index === addonIndex && addon.item_id === itemId) {
          return {
            ...addon,
            quantity: newQuantity,
            total_price: newQuantity * addon.price
          };
        }
        return addon;
      });
    });
  };

  // Prepare data for API submission (matches your Postman format)
  const handleSubmit = async (e) => {
    try {
      if (authUser.is_guest) {
        toast.error('Please login or create new account to use this feature.');
        navigate('/login?goto=item/'+id);
        return 0;
      }
      if(!checkValidations()){
        return 0;
      }
      console.log(type, address);
      if(type=="delivery" && !address?._id){
        navigate('/address-list?goto=item/'+id); 
        return 0;
      }
      else if (type=="pickup" && !branch?._id) {
        navigate('/?tab=pickup&change=1'); 
        return 0;
      }
     
      setIsLoader(true);
      const formData={
        "item_id" : item._id,
        "quantity" : quantity,
        "user_address_id" : address?._id,
        "branch_id" : branch?._id,
        "instruction" : instruction,
        "addons" : selectedAddons,
        "type": type,
      };
      
      const response = await ApiService.request({
        method: "POST",
        url: (item.cart_quantity > 0) ? "/updateCartItem": "/addItemToCart",
        data: formData
      });
      const data = response.data;
      if (data.status) {
        // toast.success(data.message);
        getItemDetails();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
    } finally {
      setIsLoader(false);
    }
  };


  const getItemDetails = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getItemDetails",
        data: {item_id: id},
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        const item=data.data;
        setItem(item);
        setQuantity(item?.cart_quantity > 0 ? item?.cart_quantity :1 );
        setTotalPrice( (item?.discounted_price)?item?.discounted_price:item?.original_price );
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      // setIsLoader(false);
    }
  };

  const getCart = async () => {
    try {
      // setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getCart",
        data:{ user_address_id: address?._id, branch_id: branch?._id, type}
      });
      const data = response.data;

      if (data.status) {
        const items=data.data?.cartItems;
        localStorage.setItem('cart_count',items.length);
        if(items){
          setCart(data.data);
          const citem=items.find(itm => itm.item_id == item._id);
          if (citem) {
            setInstruction(citem.instruction);
            setSelectedAddons(citem.addons);
          }
        }

      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    let totalPrice= (item?.discounted_price)?item?.discounted_price:item?.original_price;

    console.log(selectedAddons);

    const addonsTotal = selectedAddons.reduce((sum, addon) => {
      const addonPrice = addon.total_price ?? (addon.price * addon.quantity);
      return sum + Number(addonPrice);
    }, 0);


    totalPrice+=addonsTotal;
    totalPrice=  parseInt(totalPrice)* parseInt(quantity);

    setTotalPrice(totalPrice);
    
  }, [selectedAddons, quantity, item]);

  const checkValidations = () => {
    // 1. Validate all addons
    const validationErrors = [];
    
    item.addons.forEach((addonGroup, addon_index) => {
      // Get all selected items for this addon group
      const selectedItems = selectedAddons.filter(
        a => a.addon_index === addon_index
      );
      console.log(selectedItems);

      // A. Check min_selection (minimum number of items required)
      if (selectedItems.length < addonGroup.min_selection) {
        validationErrors.push({
          addonName: addonGroup.title,
          message: `Please select at least ${addonGroup.min_selection} items from ${addonGroup.title}`
        });
      }

      // B. Check min_quantity (minimum quantity per addon group)
      const totalQuantity = selectedItems.reduce(
        (sum, item) => sum + item.quantity, 0
      );
      
      if (totalQuantity < addonGroup.min_quantity) {
        validationErrors.push({
          addonName: addonGroup.title,
          message: `Minimum total quantity for ${addonGroup.title} is ${addonGroup.min_quantity}`
        });
      }

      // C. Check individual item min quantities (if applicable)
      selectedItems.forEach(item => {
        if (item.quantity < item.min_quantity) {
          validationErrors.push({
            addonName: addonGroup.title,
            message: `Minimum quantity for ${item.title} is ${item.min_quantity}`
          });
        }
      });
    });

    // 3. Show errors if any
    if (validationErrors.length > 0) {
      const error= validationErrors[0];
      toast.error(`${error.addonName}: ${error.message}`);

      // validationErrors.forEach(error => {
      //   toast.error(`${error.addonName}: ${error.message}`);
      // });
      return false;
    }
    return true;
  }


  return (
    <div>
      {isLoader ?(
        <PageLoader />
      ):(
        <div className="main-heading container customize">
         
        <Header title={'Customize'} />
         

          <div className="banner-section">
            <img src={item?.image} alt="" />
            <div className="banner-section-data p-4">
              <h4 className="fw-bold">{item?.title}</h4>
              <p className="text-secondary">
                {item?.description}
              </p>
              <h5>{(item?.discounted_price)?item?.discounted_price:item?.original_price } AED</h5>
            </div>
          </div>

          <h5 className="mx-3">Add extra Ingredients</h5>
          {item?.addons && item?.addons.map((addon, addonIndex) => (
            <div className="heading-items px-4 my-3" key={addonIndex}>
              <div className="d-flex">
                <p className="fs-6 fw-semibold">{addon.title}</p>
                <p className={`me-1 ${addon.min_quantity > 0 ? 'mandatory' : 'optional'}`}>
                  {`${addon.min_quantity > 0 ? 'Mandatory' : 'Optional'}`}
                </p>
                 {`${addon.min_quantity ?? 0}/${addon.max_quantity ?? 0}` }
              </div>
              <div className="extra-ingredients row">
                {addon.addon_items && addon.addon_items.map((addon_item, index) => {
                    //  console.log(addon_item);
                    const isSelected = selectedAddons.some(
                      a => a.addon_index === addonIndex && a.item_id === addon_item._id
                    );
                    const selectedAddon = selectedAddons.find(
                      a => a.addon_index === addonIndex && a.item_id === addon_item._id
                    );
                    const quantity = selectedAddon?.quantity || 0;

                    return (
                      <div className="col-md-4 col-12">
                        <div className="d-flex my-4 border bg-white rounded" key={index}
                          >
                          <div className="gredient-1 d-flex w-100">
                            <img src={addon_item?.image} alt={addon_item?.title} className="addon-img "/>
                            <div className="gredient-data mt-2">
                              <div className="cursor-pointer" onClick={() => handleCheckboxChange(addonIndex, addon_item, !isSelected)}>
                                <span>{addon_item?.title}</span>
                                <p className="text-muted fs-7 mb-1">{addon_item?.description}</p>
                              </div>
                              <div className="d-flex mt-2">
                                <p>AED +{(addon_item?.price)?addon_item?.price:"0"}</p>
                                
                                {addon_item.max_selection > 1 && isSelected && (
                                  <div className="d-flex align-items-center justify-content-center counter quantity-btn">
                                    <button className="btn btn-success btn-minus"
                                      onClick={() => handleQuantityChange(
                                        addonIndex, 
                                        addon_item._id, 
                                        Math.max(1, quantity - 1)
                                      )}
                                      disabled={quantity <= 1}
                                    > – </button>
                                    <div  className="bg-white text-success fw-bold quantity-counter" >
                                      {quantity}
                                    </div>
                                    <button
                                      className="btn btn-success btn-plus"
                                      onClick={() => handleQuantityChange(
                                        addonIndex, 
                                        addon_item._id, 
                                        Math.min( addon_item.max_selection, quantity + 1)
                                      )}
                                      disabled={quantity >= addon_item.max_selection}
                                    >  + </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div>
                            <input
                              type="checkbox"
                              className="checkbox mx-2"
                              checked={isSelected}
                              onChange={(e) => handleCheckboxChange(
                                addonIndex, 
                                addon_item, 
                                e.target.checked
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      
                    );
                })}
              </div>
            </div>
          ))}

          <div className="bottom p-3">
            

                {/* Bottom Text Area and  Buttons */}
                <div className="row">
                  <div className="col-12 col-md-6">
                    <label htmlFor="">Add Special Note</label>
                    <textarea name="note" className="form-control" rows="3"  value={instruction}
                      onChange={(e) => setInstruction( e.target.value )}
                      placeholder="Write your note"></textarea>
                  </div>
                  <div className="col-12 col-md-6">
                      <div className="row mt-3">
                        <div className="col-4 p-2">
                            <div className="d-flex  counter quantity-btn">
                              <button className="btn btn-success btn-minus" disabled={quantity <= 1}
                                onClick={() => setQuantity(parseInt(quantity)-1)}
                              > – </button>
                              <div  className="bg-white text-success fw-bold quantity-counter" >
                                {quantity}
                              </div>
                              <button
                                className="btn btn-success btn-plus"
                                onClick={() => setQuantity(parseInt(quantity)+1)}
                              >  + </button>
                            </div>
                        </div>
                        <div className="col-8 p-2">
                          <button className="btn btn-base w-100" onClick={()=>handleSubmit()}> Add Items {total_price} AED</button>
                        </div>
                      </div>
                  </div>
                  <div className="col-12 col-md-6 ">
                    {cart?.cartItems?.length > 0 &&
                      <div className="row my-3 mx-1 bg-base rounded py-3 px-2">
                        <div className="col-2 mt-2">
                            <h2 className="rounded-circle bg-danger cart-counter">{(cart.cartItems)?cart.cartItems.length:0}</h2>
                        </div>
                        <div className="col-6">
                            <h4 className="text-white">{cart?.subTotal} AED</h4>
                            <small className="text-light">inclusive of taxes</small>
                        </div>
                        <div className="col-4 text-end">
                          <Link to='/cart' className="btn btn-sm btn-warning p-2" >
                            <i className="bi bi-bag"></i> View Cart</Link>
                        </div>
                      </div>
                    }
                  </div>

                </div>
              
              

          </div>


      
      </div>
    )};
  </div>

  );
};

export default ItemDetails;
